import vancouverBladersLogo from './images/vancouver-bladers-logo-300x300.png';
import shredmontonLogo from './images/shredmonton-logo.png';
import bladersyyclogo from './images/bladers-yyc.png';
import kelownaBladersLogo from './images/Kelowna-bladers.png';

const GroupData = [
  {
    name: 'Vancouver Bladers',
    image: vancouverBladersLogo,
    description: 'Vancouver Bladers is a community In-line and Rollerskate group. We want to grow this community in a positive and supportive way.',
    instagram: 'https://www.instagram.com/vancouverbladers/',
    city: 'Vancouver',
    province: 'BC'
  },
  {
    name: 'Kelowna Bladers',
    image: kelownaBladersLogo,
    description: 'Kelownas official inline community (aggressive, street , slalom, sliding, and wizard inline)Every Tuesday 5pm Stuart Park',
    instagram: 'https://www.instagram.com/kelownabladers/',
    city: 'Kelowna',
    province: 'BC'
  },
  {
    name: 'Shredmonton',
    image: shredmontonLogo,
    description: 'Inline skating in Edmonton, Alberta',
    instagram: 'https://www.instagram.com/shredmonton.inline/',
    city: 'Edmonton',
    province: 'AB'

  },
  {
    name: 'Bladers YYC',
    image: bladersyyclogo,
    description: 'Calgary Skaters Unite!',
    instagram: 'https://www.instagram.com/bladersyyc/',
    city: 'Calgary',
    province: 'AB'
  }
];

export default GroupData;
